import { useDispatch } from "react-redux";
import Srcset from "@/components/common/Srcset";
import ProductDes from "../Sections/ProductDescriptionComp";
import ShippingReturns from "../Sections/ShippingReturns";
import Accordion from "@/common/Accordion";
import ReactSidebar from "@/common/ReactSidebar";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

import styles from "../Sections/sections.module.scss";

import { lowerHeaderZIndex } from "@/redux/actions/headerAction";

export default function GiftSections({ productDesc, isFinalSale, sizeGuideType }) {
  const dispatch = useDispatch();

  const handleSidebar = (e) => {
    dispatch(lowerHeaderZIndex(e));
  };

  const isMobile = useMediaQuery("(max-width: 767px)");

  const accordionData = [
    {
      title: "Product details",
      headerClass: "auto-details-mob",
      body: (
        <ProductDes
          productInfo={productDesc}
          showTitle={false}
          sizeGuideType={sizeGuideType}
          isGiftcard={true}
        />
      ),
      icon: {
        src: "images/Icons/Plus/large.svg",
        alt: "plus",
        animationClass: styles.icon_transition,
      },
    },
  ];

  const sidebarData = [
    {
      title: "Product details",
      headerClass: "auto-details",
      body: (
        <ProductDes
          productInfo={productDesc}
          showTitle={true}
          sizeGuideType={sizeGuideType}
          isGiftcard={true}
        />
      ),
      icon: {
        src: "images/Icons/Arrow/Right/large.svg",
        alt: "right-arrow",
      },
    },
  ];

  return (
    <>
      {/* Desktop View */}
      {!isMobile && (
        <div className="d-none d-md-block">
          {sidebarData.map((ele, index) => {
            return (
              <ReactSidebar
                key={index}
                mainContent={
                  <div
                    className={`small-xs small-sm large-md ${styles.section_header}`}
                  >
                    <span>{ele?.title}</span>
                    <div className={`${styles["right-arrow"]}`}>
                      <Srcset
                        height={15}
                        width={15}
                        alt={ele?.icon?.alt}
                        requirePath={true}
                        svgFile={true}
                        src={ele?.icon?.src}
                      />
                    </div>
                  </div>
                }
                handleSidebar={handleSidebar}
                sidebarContent={ele?.body}
                rootClassName={`${styles.root_class}`}
                pullRight={true}
                styles={{
                  sidebar: {
                    position: "fixed",
                    overflow: "auto",
                  },
                }}
              />
            );
          })}


        </div>
      )}

      {/* Mobile View */}
      {isMobile && (
        <div className="d-none d-sm-block">
          <Accordion data={accordionData} />
        </div>
      )}
    </>
  );
}
